"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _usageTracker = _interopRequireDefault(require("../../lib/usageTracker"));

var _TrialConstants = require("../../constants/TrialConstants");

var _Logo = _interopRequireDefault(require("../Logo"));

var _VideoModal = _interopRequireDefault(require("../VideoModal"));

var _chatPerson = _interopRequireDefault(require("bender-url!../../../img/chat-person.png"));

var _Urls = require("../../util/Urls");

var getLangKey = function getLangKey() {
  return window.I18N_MANUAL_LANG;
};

var FormattedLangMessage = (0, _react.memo)(function () {
  if (window.I18N_MANUAL_LANG !== 'en') {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "trialCtaPage.cmsParagraph-alt"
    });
  }

  return _react.default.createElement(_FormattedMessage.default, {
    message: "trialCtaPage.cmsParagraph"
  });
});

var TrialCtaPage = function TrialCtaPage(_ref) {
  var websiteUrl = _ref.websiteUrl;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showVideo = _useState2[0],
      setShowVideo = _useState2[1];

  var lang = getLangKey();
  var showLanguageAlt = lang !== 'en';
  var parsedUtmParams = (0, _Urls.parseUtmParams)();

  var handleClick = function handleClick() {
    _usageTracker.default.log('trialBannerClick', {
      type: 'dtt-cta-click',
      websiteUrl: websiteUrl,
      source: 'trial-cta-footer'
    });
  };

  var onShowVideoModal = function onShowVideoModal() {
    setShowVideo(!showVideo);
  };

  return _react.default.createElement("div", {
    className: "trial-cta-page",
    "data-reagan-selector": "trial-cta-page"
  }, _react.default.createElement("div", {
    className: "wsg-container trial-cta-container"
  }, showVideo && _react.default.createElement(_VideoModal.default, {
    handleClose: onShowVideoModal,
    ctaLink: _TrialConstants.CTA_BOTTOM_BANNER_LINK + "&" + parsedUtmParams
  }), _react.default.createElement("div", {
    className: "cta-container"
  }, _react.default.createElement("div", {
    className: "cta-image-left"
  }, _react.default.createElement("img", {
    src: _chatPerson.default
  })), _react.default.createElement("div", {
    className: "cta-info-right"
  }, _react.default.createElement("div", {
    className: "trial-cta-header"
  }, _react.default.createElement("div", {
    className: "product-logo"
  }, _react.default.createElement(_Logo.default, null)), _react.default.createElement("div", {
    className: "header"
  }, _react.default.createElement(_FormattedMessage.default, {
    className: "header",
    message: "trialCtaPage.header"
  }))), _react.default.createElement("div", {
    className: "paragraph"
  }, _react.default.createElement(FormattedLangMessage, null)), showLanguageAlt ? _react.default.createElement("div", {
    className: "trial-cta-button"
  }, _react.default.createElement("a", {
    className: "button white",
    href: _TrialConstants.LanguageCTALinks[lang] + "&" + parsedUtmParams,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: 'trialBanner.ctaButtonGetGuide'
  }))) : _react.default.createElement("div", {
    className: "trial-cta-button"
  }, _react.default.createElement("a", {
    className: "button secondary-ghost",
    onClick: onShowVideoModal,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "trialBanner.ctaButtonWatchVideo"
  })), _react.default.createElement("a", {
    className: "button white",
    onClick: handleClick,
    href: _TrialConstants.CTA_BOTTOM_BANNER_LINK + "&" + parsedUtmParams,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "trialBanner.ctaButtonCourse"
  }))), _react.default.createElement("div", {
    className: "microcopy"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "trialCtaPage.microcopy"
  }))))));
};

TrialCtaPage.propTypes = {
  websiteUrl: _propTypes.default.string.isRequired
};
var _default = TrialCtaPage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/TrialCtaPage.js
// module id = 272
// module chunks = 0